// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__ExM5Q","error":"styles_error__ydVjR","tapTarget":"styles_tapTarget__lUGM_","tooltip":"styles_tooltip__XfgEU"};